'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _dateToDateString = require('./dateToDateString');

var _dateToDateString2 = _interopRequireDefault(_dateToDateString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
    return (0, _dateToDateString2.default)(new Date());
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/date/todayLocaleString.js
// module id = 76
// module chunks = 0